import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as etcAction from 'actions/etc';
import { Button, Modal } from 'semantic-ui-react';
import { LoadingBar } from 'components/Commons';

const propTypes = {
  modalAction: PropTypes.objectOf(PropTypes.any).isRequired,
  modal: PropTypes.shape({
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    size: PropTypes.string,
    open: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    footerButton: PropTypes.element,
    close: PropTypes.func
  })
};

const defaultProps = {
  modal: {
    content: '',
    size: 'large',
    open: false,
    title: '',
    footerButton: null,
    close: null
  }
};

class RootCommonModal extends Component {
  close = async () => {
    const { modal, modalAction } = this.props;
    if (modal.close) {
      await modal.close({ type: 'ok' });
    }
    modalAction.toggle({ ...modal, open: false });
  };

  render() {
    const { modal } = this.props;
    const { content, size, open, title, footerButton } = modal;
    // const { content: contents, page, pageRow, total } = data;
    let loading = <LoadingBar />;
    if (content) {
      loading = null;
    }

    return (
      <Modal className="login-history" size={size} open={open} onClose={this.close}>
        <Modal.Header>{title}</Modal.Header>
        <Modal.Content>
          <div>
            {loading}
            {content}
          </div>
        </Modal.Content>
        <Modal.Actions>
          {footerButton || (
            <Button className="ok" inverted color="green" onClick={this.close}>
              로그아웃
            </Button>
          )}
        </Modal.Actions>
      </Modal>
    );
  }
}

RootCommonModal.propTypes = propTypes;
RootCommonModal.defaultProps = defaultProps;

export default connect(
  (state) => ({
    modal: state.etc.modal
  }),
  (dispatch) => ({
    modalAction: bindActionCreators(
      {
        toggle: etcAction.RootCommonModalAction
      },
      dispatch
    )
  })
)(RootCommonModal);
